module.exports = __webpack_public_path__ + "43a6109f6570349f44a9655513f07308.svg";